import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { LandingModel } from 'Pages/orders'

type ExternalFormLandingsState = {
	searchLandings: string[]
	allLandings: string[]
}

const initialExternalFormLandingsState: ExternalFormLandingsState = {
	searchLandings: [],
	allLandings: [],
}

export namespace ExternalFormLandingsNS {
	export type GetAll = PayloadAction<{
		params: RequestParams
	}>
	export type GetSearch = PayloadAction<{
		params: RequestParams
	}>
	export type SetAll = PayloadAction<ResponseCatalog<LandingModel>>
	export type SetSearch = PayloadAction<ResponseCatalog<LandingModel>>
}

export const externalFormLandingsSlice = createSlice({
	name: 'externalFormsLandings',
	initialState: initialExternalFormLandingsState,
	reducers: {
		getAll: (state, action: ExternalFormLandingsNS.GetAll) => {},
		setAll: (state, action: ExternalFormLandingsNS.SetAll) => {
			state.allLandings = action.payload.entries.map((landing) => landing.link)
		},
		getSearch: (state, action: ExternalFormLandingsNS.GetSearch) => {},
		setSearch: (state, action: ExternalFormLandingsNS.SetSearch) => {
			state.searchLandings = action.payload.entries.map((landing) => landing.link)
		},
		clearAll: (state) => {
			state.allLandings = []
			state.searchLandings = []
		},
		clearSearch: (state) => {
			state.searchLandings = []
		},
	},
})
